import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { COLOR_GRAY_70 } from 'styles/variables/colors';

const useStyles = makeStyles(() => ({
  greyText: {
    color: COLOR_GRAY_70,
  },
}));

const GreyText = ({ children }) => {
  const classes = useStyles();

  return <Typography className={classes.greyText}>{children}</Typography>;
};

export default function ExternalPaymentContent({ methodLabel, isSingleUse }) {
  return (
    <>
      {isSingleUse && (
        <Box mb={2}>
          <GreyText>
            {methodLabel} is a single use payment method and <b>does not have automatic renewals</b>
            . If you want to continue using your subscription after it ends, you must return to this
            page and make a new payment manually.
          </GreyText>
        </Box>
      )}

      <GreyText>
        Please click "Complete Subscription" to purchase with {methodLabel}. You will be redirected
        to another page to complete your payment.
      </GreyText>
    </>
  );
}
